import { SvgIcon, SvgIconProps } from "@mui/material";

export function OfficeIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 30 30" {...props}>
      <path d="M2.5 26.25V3.75H15v5h12.5v17.5h-25zm2.5-2.5h2.5v-2.5H5v2.5zm0-5h2.5v-2.5H5v2.5zm0-5h2.5v-2.5H5v2.5zm0-5h2.5v-2.5H5v2.5zm5 15h2.5v-2.5H10v2.5zm0-5h2.5v-2.5H10v2.5zm0-5h2.5v-2.5H10v2.5zm0-5h2.5v-2.5H10v2.5zm5 15h10v-12.5H15v2.5h2.5v2.5H15v2.5h2.5v2.5H15v2.5zm5-7.5v-2.5h2.5v2.5H20zm0 5v-2.5h2.5v2.5H20z" />
    </SvgIcon>
  );
}
